import { HTMLInputTypeAttribute, useState } from 'react';
import './inputField.scss';

interface IIinputField {
  value?: number | string;
  name: string;
  label: string;
  required?: boolean;
  disabled?: boolean;
  onChange?: any;
  error?: boolean;
  style?: any;
  type?: HTMLInputTypeAttribute | undefined;
  className?: string;
  classNameInput?: string;
  errorLabel?: string;
  idLabel?: string;
  minScale?: number;
  maxScale?: number;
  maxLength?: number;
  placeholder?: string;
}

export default function InputField({
  value,
  name,
  required,
  disabled,
  onChange,
  error,
  label,
  style,
  type,
  className,
  classNameInput,
  errorLabel,
  idLabel,
  minScale,
  maxScale,
  maxLength,
  placeholder,
}: IIinputField) {
  const [focused, setFocused] = useState(false);
  return (
    <div className={className ? className : 'input-field'} style={{ ...style }}>
      <label htmlFor={idLabel ?? label}>
        {label} {required && <i className='icon-asterisk' />}
      </label>
      <input
        id={idLabel ?? label}
        type={type ?? 'text'}
        name={name}
        value={value}
        min={minScale}
        max={maxScale}
        maxLength={maxLength}
        className={
          classNameInput ? classNameInput : `${error && '--error'} ${focused && '--focused'}`
        }
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        onChange={(e) => onChange && onChange(e)}
        placeholder={placeholder}
        disabled={disabled}
        autoComplete='off'
      />
      {errorLabel && <span className='error-label'>{errorLabel}</span>}
    </div>
  );
}
